"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleText = void 0;
var _index = require("../../styles/index.js");
var _index2 = require("../Text/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var TitleText = exports.TitleText = (0, _styledComponents["default"])(_index2.Text).withConfig({
  displayName: "TitleText",
  componentId: "sc-1t77w68-0"
})(["min-inline-size:0;overflow-wrap:break-word;margin-inline-end:", ";"], (0, _index.cssSpacing)('base', '16px'));